export const ebCategories = [
  {
    id: "eb1a",
    name: "EB-1A: Extraordinary Ability",
    nameZh: "EB-1A：杰出人才",
    selfPetition: true,
    employerRequired: false,
    permRequired: false,
    jobOfferRequired: false,
    educationMin: "No specific requirement",
    educationMinZh: "无特定学历要求",
    premiumProcessing: "15 days",
    standardTime: "6-12 months",
    totalTimelineROW: "1-2 years",
    difficulty: "High",
    difficultyZh: "高",
    description:
      "For individuals who demonstrate extraordinary ability in sciences, arts, education, business, or athletics through sustained national or international acclaim. Must meet 3 of 10 criteria or show a one-time major achievement.",
    descriptionZh:
      "适用于在科学、艺术、教育、商业或体育领域通过持续的国家或国际声誉展示杰出能力的人。需满足10项标准中的3项，或展示一次性重大成就。",
    bestFor: "Researchers, entrepreneurs, and professionals with a strong track record of recognized achievements",
    bestForZh: "有公认成就记录的研究人员、企业家和专业人士",
    pros: [
      "Self-petition — no employer sponsorship needed",
      "No job offer required",
      "No PERM labor certification needed",
      "Priority date is current for most countries",
      "Premium processing available (15 days)",
    ],
    prosZh: [
      "可自行申请——无需雇主担保",
      "无需工作offer",
      "无需PERM劳工认证",
      "大多数国家的优先日期为当前",
      "可加急处理（15天）",
    ],
    cons: [
      "Highest evidentiary burden — must prove extraordinary ability",
      "Requires extensive documentation of achievements",
      "RFE (Request for Evidence) rates can be high",
      "Denial rate higher than employer-sponsored categories",
    ],
    consZh: [
      "举证要求最高——需证明杰出能力",
      "需要大量成就文档",
      "补件（RFE）比率可能较高",
      "拒绝率高于雇主担保类别",
    ],
  },
  {
    id: "eb1b",
    name: "EB-1B: Outstanding Researcher/Professor",
    nameZh: "EB-1B：杰出教授/研究人员",
    selfPetition: false,
    employerRequired: true,
    permRequired: false,
    jobOfferRequired: true,
    educationMin: "3+ years of research experience",
    educationMinZh: "3年以上研究经验",
    premiumProcessing: "15 days",
    standardTime: "6-12 months",
    totalTimelineROW: "1-2 years",
    difficulty: "High",
    difficultyZh: "高",
    description:
      "For outstanding professors and researchers with at least 3 years of research experience who are recognized internationally. Requires a permanent job offer from a university or research institution.",
    descriptionZh:
      "适用于具有至少3年研究经验且获国际认可的杰出教授和研究人员。需有大学或研究机构的永久职位offer。",
    bestFor: "Academic researchers and professors with strong publication records",
    bestForZh: "有优秀发表记录的学术研究人员和教授",
    pros: [
      "No PERM labor certification required",
      "Priority date is current for most countries",
      "Premium processing available (15 days)",
      "Slightly lower bar than EB-1A for academics",
    ],
    prosZh: [
      "无需PERM劳工认证",
      "大多数国家的优先日期为当前",
      "可加急处理（15天）",
      "对学术人员的门槛略低于EB-1A",
    ],
    cons: [
      "Requires employer sponsorship",
      "Must have a permanent job offer",
      "Limited to research/academic positions",
      "Employer must demonstrate distinguished reputation",
    ],
    consZh: [
      "需要雇主担保",
      "需有永久职位offer",
      "仅限研究/学术职位",
      "雇主需证明其卓越声誉",
    ],
  },
  {
    id: "eb2perm",
    name: "EB-2 PERM: Advanced Degree Professional",
    nameZh: "EB-2 PERM：高级学位专业人员",
    selfPetition: false,
    employerRequired: true,
    permRequired: true,
    jobOfferRequired: true,
    educationMin: "Master's degree or Bachelor's + 5 years experience",
    educationMinZh: "硕士学位或学士学位+5年经验",
    premiumProcessing: "15 days",
    standardTime: "1-2 years (including PERM)",
    totalTimelineROW: "2-4 years",
    difficulty: "Moderate",
    difficultyZh: "中等",
    description:
      "For professionals with advanced degrees or exceptional ability. Requires PERM labor certification proving no qualified U.S. workers are available. Most common employer-sponsored green card path.",
    descriptionZh:
      "适用于拥有高级学位或特殊能力的专业人员。需PERM劳工认证证明无合格美国工人。最常见的雇主担保绿卡途径。",
    bestFor: "Professionals with Master's degrees or higher in employer-sponsored roles",
    bestForZh: "在雇主担保岗位上拥有硕士及以上学位的专业人员",
    pros: [
      "Well-established and predictable process",
      "Premium processing available (15 days)",
      "Lower evidentiary burden than EB-1",
      "Most major employers have established processes",
    ],
    prosZh: [
      "流程成熟且可预测",
      "可加急处理（15天）",
      "举证要求低于EB-1",
      "大多数大公司有成熟流程",
    ],
    cons: [
      "PERM process adds 6-18 months",
      "Tied to specific employer and job",
      "Severe backlogs for India and China",
      "Job change during process can reset timeline",
      "Employer bears cost and effort of PERM recruitment",
    ],
    consZh: [
      "PERM流程增加6-18个月",
      "绑定特定雇主和职位",
      "印度和中国申请人严重积压",
      "流程中换工作可能重置时间线",
      "雇主承担PERM招聘的成本和工作量",
    ],
  },
  {
    id: "eb2niw",
    name: "EB-2 NIW: National Interest Waiver",
    nameZh: "EB-2 NIW：国家利益豁免",
    selfPetition: true,
    employerRequired: false,
    permRequired: false,
    jobOfferRequired: false,
    educationMin: "Master's degree or exceptional ability",
    educationMinZh: "硕士学位或特殊能力",
    premiumProcessing: "45 business days",
    standardTime: "6-18 months",
    totalTimelineROW: "1.5-3 years",
    difficulty: "Moderate-High",
    difficultyZh: "中高",
    description:
      "Waiver of the job offer and PERM requirements for EB-2 applicants whose work is in the national interest of the United States. Must pass the three-prong Matter of Dhanasar test: substantial merit, national scope, and benefit to the U.S. to waive the requirements.",
    descriptionZh:
      "为工作符合美国国家利益的EB-2申请人豁免工作offer和PERM要求。需通过Dhanasar三要素测试：实质性价值、全国范围影响、以及豁免要求对美国有利。",
    bestFor: "STEM researchers, entrepreneurs, and professionals whose work benefits the U.S. broadly",
    bestForZh: "工作对美国有广泛益处的STEM研究人员、企业家和专业人士",
    pros: [
      "Self-petition — no employer sponsorship needed",
      "No job offer or PERM required",
      "Can file while on any valid status",
      "Lower bar than EB-1A for many applicants",
      "Premium processing now available (45 business days)",
    ],
    prosZh: [
      "可自行申请——无需雇主担保",
      "无需工作offer或PERM",
      "持任何有效身份均可申请",
      "对许多申请人而言门槛低于EB-1A",
      "现已可加急处理（45个工作日）",
    ],
    cons: [
      "Subject to EB-2 visa bulletin backlogs (India/China)",
      "Must demonstrate national interest — not just personal benefit",
      "Premium processing slower than EB-1 (45 biz days vs 15 calendar days)",
      "Relatively subjective standard can lead to inconsistent outcomes",
    ],
    consZh: [
      "受EB-2签证排期积压影响（印度/中国）",
      "需证明国家利益——不仅是个人利益",
      "加急处理比EB-1慢（45个工作日vs15个日历日）",
      "标准相对主观，可能导致结果不一致",
    ],
  },
  {
    id: "eb3",
    name: "EB-3: Skilled Workers & Professionals",
    nameZh: "EB-3：技术工人和专业人员",
    selfPetition: false,
    employerRequired: true,
    permRequired: true,
    jobOfferRequired: true,
    educationMin: "Varies (Bachelor's for professionals, 2+ years training for skilled workers)",
    educationMinZh: "因类别而异（专业人员需学士学位，技术工人需2年以上培训）",
    premiumProcessing: "15 days",
    standardTime: "1-2 years (including PERM)",
    totalTimelineROW: "3-5 years",
    difficulty: "Low-Moderate",
    difficultyZh: "低至中等",
    description:
      "For skilled workers with 2+ years of training/experience, professionals with bachelor's degrees, and other workers. Requires PERM labor certification and a permanent full-time job offer.",
    descriptionZh:
      "适用于有2年以上培训/经验的技术工人、拥有学士学位的专业人员和其他工人。需PERM劳工认证和永久全职工作offer。",
    bestFor: "Workers with Bachelor's degrees or skilled trades who have employer sponsorship",
    bestForZh: "有雇主担保的学士学位持有者或技术工人",
    pros: [
      "Lower qualification requirements than EB-1 or EB-2",
      "Well-established process similar to EB-2 PERM",
      "Premium processing available (15 days)",
      "Good option when EB-2 qualifications are not met",
    ],
    prosZh: [
      "资格要求低于EB-1或EB-2",
      "与EB-2 PERM相似的成熟流程",
      "可加急处理（15天）",
      "不满足EB-2资格时的好选择",
    ],
    cons: [
      "Longest visa bulletin backlogs among EB categories",
      "Requires PERM labor certification",
      "Tied to specific employer and job",
      "India/China backlogs can exceed 10+ years",
      "Limited career flexibility during the process",
    ],
    consZh: [
      "EB类别中排期积压最长",
      "需要PERM劳工认证",
      "绑定特定雇主和职位",
      "印度/中国积压可超过10年以上",
      "流程期间职业灵活性有限",
    ],
  },
];
